@import 'styles/mixins';
@import 'styles/blaze/mixins';

.reviewRequestCard {
  @include blur(35px);
  border-radius: 8px;
  padding: 15px;
  background: var(--light-80);
  gap: 15px;
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.9) inset, 0px 2px 12px 0px rgba(0, 0, 0, 0.04);

  [data-autopilot-system-redesign='on'] & {
    box-shadow: none;
    border: none;
    margin-bottom: 0;

    &.isDesign {
      border: 1px solid var(--dark-8);
      background: rgb(251 251 251);
      padding: 15px;
    }
  }

  @include for-phone-only {
    border-radius: 0;
    background-color: var(--default-bg);
    margin-bottom: 0;

    &.isPostableOrDesign {
      background-color: var(--light-80);

      .footer {
        gap: 15px;
      }
    }
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .rightSide {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.title {
  display: flex;
  align-items: center;
  gap: 5px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
  align-items: flex-start;
}

.titleContainer {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.reviewers {
  width: 100%;
  margin-top: 5px;

  .review {
    width: 100%;
    padding: 5px 5px 5px 0;
    border-top: 1px solid var(--dark-4);
    display: flex;
    align-items: center;
    height: 35px;
    gap: 10px;

    &:first-child {
      border-top: none;
    }

    .reviewer {
      @include line-clamp;
      width: 128px;
      margin-right: 8px;
    }
  }

  &.withMoreReviewers {
    border-bottom: 1px solid var(--dark-4);
  }
}

.reviewResult {
  display: flex;
  align-items: center;
  gap: 5px;
}

.moreReviewers {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;

  .counter {
    @include sm-sohne;
    border-radius: 12px;
    background: var(--dark-4);
    height: 20px;
    padding: 0 6px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.yourResult {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 5px;
}

.creationDate {
  @include xs-sohne-book;
  color: var(--dark-60);
  display: inline-flex;
  margin-right: 2px;
}
